import { useTranslation } from 'react-i18next'

const AccessDenied = () => {
  const { t } = useTranslation()
  return (
    <div>
      <p>{t('access.denied')}</p>
      <p>
        <a href="https://portal.eleneo.fr/">{t('access.backToPortal')}</a>
      </p>
    </div>
  )
}

export default AccessDenied
